import MenuOrderStepsPanel from './MenuOrderStepsPanel';
import MenuOrderComboPanel from "./MenuOrderComboPanel";
import CustomizedMenuRightModal from './CustomizedMenuRightModal';
import SelectedComboItem from './SelectedComboItem';    
import ComboOrderButton from "./ComboOrderButton";
const { timesSeries } = require('async');

export default class ComboPage extends React.Component {
    constructor(props) {
        super(props);
        this.allComboData = this.props.data; // new combo dynamically fetched data  
       // //console.log('allComboData', this.allComboData);
        this.choiceIds = this.allComboData.SelectedChoices ? this.allComboData.SelectedChoices : [];
        this.pdpOrdersDataForEdit = this.allComboData.CartItem;
       // //console.log('pdpOrdersDataForEdit', this.pdpOrdersDataForEdit);
        this.state = {
            currentSelectedItems: [],
            updatedId: [],
            updateView:0,
            cardRackPosition: null,
            selectedCardId: 0,
            allCardIdData: [],
            editPage: false,
            AllToppingsData: [],
            idOfremovedCard: 0,
            AllToppingsHeaderTitle: [],
            AllToppingsHeaderId: [],    
            showHideOrderPanel: false, //shows all order panels by default
            orderModalTitle: false,
            hidePanel: false,
            allOrderPanels: this.allComboData.ModifierGroups,
            OrderStepsPanelObj: [],
            filteredTitleObject: [],
            cardOpensModal: false,
            cardNameClicked: "",
            selectedIdData: [],
            isCustomizedButtonClicked: [false],
            checkboxInfo: [],
            removeOrPersistSelectedItem: [false],
            extrasPrice: 0,
            modifiedIds: [],
            numberOfStacks: [],
            initialPrice: this.pdpOrdersDataForEdit.id != 0 ? this.allComboData.CartItem.basecost : this.allComboData.MenuItem.CalcPrice,
            resetModal: false,
            modalTitleForReset: "",
            renderCardName: "",
            filteredOptionalCards: [],
            removeIdDataForModalReset: 0,
            cardOnlyPrice: 0,
            modalId: 0,
            afilterEventOccured: false,
            ModalImage: null,
            instruction: (this.props.data && this.props.data.CartItem && this.props.data.CartItem.specialinstructions) || '',
            error: ''
        }

        this.getSelectedMenuCardData = this.getSelectedMenuCardData.bind(this);
        this.getMenuOrderCardData = this.getMenuOrderCardData.bind(this);
        this.getIdDataForCardRemoval = this.getIdDataForCardRemoval.bind(this);
        this.receiveToppingsDataForToppingComp = this.receiveToppingsDataForToppingComp.bind(this)
        this.receiveModalHeaderTextForComboToppingsComp = this.receiveModalHeaderTextForComboToppingsComp.bind(this)
        this.receiveModalHeaderIdForComboToppingsComp = this.receiveModalHeaderIdForComboToppingsComp.bind(this)
        this.getCommaSeparatedDataForParent = this.getCommaSeparatedDataForParent.bind(this)
        this.receiveModalImage = this.receiveModalImage.bind(this);
        this.getModalInfoToRemoveSelecetedItem = this.getModalInfoToRemoveSelecetedItem.bind(this);
        this.getSelecetedItemTitleToShowMenuOrderPanel = this.getSelecetedItemTitleToShowMenuOrderPanel.bind(this)
        this.checkButtonStatusOnCardClick = this.checkButtonStatusOnCardClick.bind(this);
        this.getModifierGroupIdByMenuDetailId = this.getModifierGroupIdByMenuDetailId.bind(this);
        this.sendDataForRemoval = this.sendDataForRemoval.bind(this);
        this.updateRenderModalState = this.updateRenderModalState.bind(this);
        this.ModalMainToppingsHeader = null;
        this.OrderStepsPanelObj = null;
        this.modifiedSelectionText = null;
        this.getAppendedDataObj = "";
        this.getSubsLabelId = "",
        this.choiceIdOnEdit = [];
        this.getAppendedData = this.getAppendedData.bind(this)
        this.preselectDefaultItems = this.preselectDefaultItems.bind(this);
        this.getIdForSubs = this.getIdForSubs.bind(this);
        this.getModalResetState = this.getModalResetState.bind(this)
        this.renderChoiceIdsOnSave = this.renderChoiceIdsOnSave.bind(this);
        this.getCustomizedButtonClickedStatus = this.getCustomizedButtonClickedStatus.bind(this);
        //this.getTitleDataToHideAndShow = this.getTitleDataToHideAndShow.bind(this);
        this.resetCardOpensModalStatus = this.resetCardOpensModalStatus.bind(this)
        this.getNameListForModalMultiples = this.getNameListForModalMultiples.bind(this)
        //this.disableModalOnRemove = false;
        this.getCardOpensModalState = this.getCardOpensModalState.bind(this);
        this.getUpdatedToppingData = this.getUpdatedToppingData.bind(this);
        this.getExtrasPrice = this.getExtrasPrice.bind(this);
        this.getUpdatedComboPrice = this.getUpdatedComboPrice.bind(this)
        this.getUpdatedExtrasPrice = this.getUpdatedExtrasPrice.bind(this)
        this.getIdForCloseButton = this.getIdForCloseButton.bind(this)
        this.getNotificationToResetCheckboxes = this.getNotificationToResetCheckboxes.bind(this)
        this.getToppingHeaderTitleWithSub = this.getToppingHeaderTitleWithSub.bind(this)
        this.getCommaJoiningDataFormenuSub = this.getCommaJoiningDataFormenuSub.bind(this)
        this.getCardNameForModalReset = this.getCardNameForModalReset.bind(this)
        this.renderChoiceIds = this.renderChoiceIds.bind(this);
        this.returnCartItemObject = this.returnCartItemObject.bind(this);
        this.getUpdatedEditModeFromHome = this.getUpdatedEditModeFromHome.bind(this)
        this.buildSelectedOrders = this.buildSelectedOrders.bind(this)
        this.getOptionGroupDataForEdit = this.getOptionGroupDataForEdit.bind(this);
        this.checkAllSelectedElements = this.checkAllSelectedElements.bind(this);
        this.checkAllDropdownElements = this.checkAllDropdownElements.bind(this);
        //this.removeSelectedCardFromRack = this.removeSelectedCardFromRack.bind(this);
       // this.hideRacksOnEmptyOptionData = this.hideRacksOnEmptyOptionData.bind(this);
        this.getCardOnlyPrice = this.getCardOnlyPrice.bind(this);
        this.getIdDataToResetAllModalControls = this.getIdDataToResetAllModalControls.bind(this);
        //this.getTotalNumberOfMinimumSelections = this.getTotalNumberOfMinimumSelections.bind(this)
        this.pushItemViewToGA = this.pushItemViewToGA.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.getIdForSaveButton = "";
        this.listOfChoiceIds = [];
        this.choiceObjects = [];
        this.allRequiredChoices = [];
        this.noOfRequiredTitles = 0;
        this.allNonRequiredComboChoicesId = [];
        this.allComboData.ModifierGroups.map(modifier => {
            modifier.Modifiers.map(cardsUniqueIds => {
                this.state.allCardIdData.push(cardsUniqueIds) // all combo cards data in one place
            })
        })
    }
    componentDidUpdate(prevProps, prevState) {
        // Check if extrasPrice or other relevant state has changed  
        if (prevState.extrasPrice !== this.state.extrasPrice) {
            // Force re-render of ComboOrderButton by updating a key or triggering a state update  
            //console.log('extrasPrice changed, forcing re-render of ComboOrderButton');  
            
        }
    }
    updateRenderModalState() {  
        console.log('updateRenderModalState called, forcing re-render of ComboOrderButton');
       this.setState((prevState) => ({  
           updateView: prevState.updateView + 1  
       }));  
    }
    getIdDataToResetAllModalControls(modalId) {
        $(document).ready(function (e) {
            setTimeout(() => {
                var required = "- required"
                var allChecBoxes = $('div[data-modalid="' + modalId + '"] input')
                var allChevrons = $('div[data-modalid="' + modalId + '"] i')
                allChecBoxes.prop('checked', false)
                allChevrons.attr("data-selected", "notSelected")
                allChevrons.closest(".cart-items").removeClass("selected");

                allChevrons.parent('div#moreOptions').parent('div.col-2').siblings('.js-cart-item-product-img').find('i.selected-combo').addClass('d-none');

                // disable save if isquired
                var isRequired = $('div[data-modalid="' + modalId + '"]').find(".category-title").text();
                if (isRequired.indexOf(required) != -1) {
                    $('#comboSaveButton').prop('disabled', true)
                }

            }, 300)
        })
    }

    pushItemViewToGA() {
        try {
            if (this.allComboData && this.allComboData.MenuItem) {
                var menuprice = this.allComboData.MenuItem.Price ? this.allComboData.MenuItem.Price.replace('$', '') : undefined;
                const source = localStorage.getItem('view_item_source') || 'menu';
                localStorage.setItem('add_to_cart_source', source);
                localStorage.setItem('add_to_cart_timestamp', Date.now().toString());
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    'event': 'view_item',
                    'ecommerce': {
                        'currency': 'USD',
                        'source': source,
                        'items': [
                            {
                                'item_id': this.allComboData.MenuItem.ChainProductId,
                                'item_name': this.allComboData.MenuItem.Name,
                                'item_brand': 'ihop',
                                'item_category': this.allComboData.MenuItem.Category,
                                'item_category2': 'undefined',
                                'item_category3': 'undefined',
                                'item_category4': 'undefined',
                                'item_variant': this.allComboData.MenuItem.VariationName,
                                'affiliation': 'undefined',
                                'price': menuprice,
                                'discount': 'undefined',
                                'quantity': '1'
                            }
                        ]
                    }
                });
                localStorage.removeItem('view_item_source');
                localStorage.removeItem('source_timestamp');
                //window.dataLayer = window.dataLayer || [];
                //window.dataLayer.push({ ecommerce: null });
                //window.dataLayer.push({
                //    'event': 'view_item_list',
                //    'ecommerce': {
                //        'currency': 'USD',
                //        'items': [
                //            {
                //                'item_name': this.allComboData.MenuItem.Name,
                //                'item_id': this.allComboData.MenuItem.ChainProductId,
                //                'currency': 'USD',
                //                'item_brand': 'ihop',
                //                'item_category': this.allComboData.MenuItem.Category,
                //                'item_category2': 'undefined',
                //                'item_category3': 'undefined',
                //                'item_category4': 'undefined',
                //                'item_variant': this.allComboData.MenuItem.VariationName,
                //                'affiliation': 'undefined',
                //                'price': menuprice,
                //                'discount': 'undefined',
                //                'quantity': '1'
                //            }
                //        ]
                //    }
                //});
            }
        }
        catch (ex) {
            //console.log(ex);
        }
    }

    getCardOnlyPrice(priceOfClickedCard) {
        var cardKey = this.state.renderCardName
        sessionStorage.setItem([cardKey], priceOfClickedCard)
        this.setState({ cardOnlyPrice: priceOfClickedCard })
    }

    //this method also caters for when minimum selection is null
/*    hideRacksOnEmptyOptionData(emptyOptionalCard, selectedRackTitle) {
        //this method will be called when maxselect is reached
        var MenuOrderPanelsHidden = [];
        this.state.allOrderPanels.map((cardRackObj, index) => {
            if (selectedRackTitle != cardRackObj.Name) {
                MenuOrderPanelsHidden[index] = cardRackObj
            }
        })
        this.state.allOrderPanels = []
        setTimeout(() => {
            this.setState({ allOrderPanels: MenuOrderPanelsHidden })
        }, 500)

        setTimeout(() => {
            $('html, body').animate({
                scrollTop: ($("#selectAnchor").position()) ? ($(window).width() <= '575') ? $("#selectAnchor").position().top + $(".combo-body").height() + 45 : $("#selectAnchor").position().top - 46 : null
            }, 500);

        }, 300)
        return emptyOptionalCard;
    }*/

    componentDidMount() {
        var cardRackRequiredTitles = $(".h1.category-title:contains('- required')")
        this.noOfRequiredTitles = cardRackRequiredTitles.length;

        $(".add-to-bag-button").click(function (e) {
            $(".combo-required-text").css("color", "red")
        })
        this.allNonRequired = this.allComboData.ModifierGroups.filter((panelObj, index) => {
            return !(panelObj.IsRequired)
        })

        //if cartItem Exists
        if (this.pdpOrdersDataForEdit.id !== 0) {
            // alert("In edit mode")\
            //console.log("In edit mode")
            this.buildSelectedOrders();
        } else {
            this.preselectDefaultItems();
        }

        this.pushItemViewToGA();
    }

    preselectDefaultItems() {
        $('[data-isdefault="true"]').click();
    }

    getModifierGroupIdByMenuDetailId(menuDetailId) {  
       if (!this.allComboData || !this.allComboData.ModifierGroups) {  
           return null;  
       }  

       const modifierGroup = this.allComboData.ModifierGroups.find(group =>  
           group.Modifiers.some(modifier => modifier.MenuItemDetail.Id == menuDetailId)  
        );
       return modifierGroup ? modifierGroup.Id : null;  
    }
  /*  buildSelectedOrders() {
        const allComboChoices = this.pdpOrdersDataForEdit.choices;

        const processChoice = (choice, catId, subTitle = null, cost = 0, modifierIds = []) => {
            *//*console.log("Processing choice:", choice.name, "with catId:", catId, "subTitle:", subTitle, "cost:", cost, "modifierIds:", modifierIds);    
            const existingItem = this.state.currentSelectedItems.find(item => item.id === choice.optionid);
            console.log("Existing item found:", existingItem);  
            if (!existingItem) { 
            // } *//*
            //console.log("Adding choice to currentSelectedItems:", choice.name, "with catId:", catId);  
            this.state.currentSelectedItems = this.state.currentSelectedItems.filter(item => item.id !== choice.optionid);  
            this.state.currentSelectedItems.push(this.returnCartItemObject(  
                catId,  
                choice.name,  
                choice.optionid,  
                choice.calories,  
                subTitle,  
                cost || choice.cost,  
                choice.image,  
                modifierIds,  
                choice.calorieSeparator,  
                choice.maxcalories  
            ));  
           
        };

        allComboChoices.forEach((choice, index) => {


            const catId = this.getModifierGroupIdByMenuDetailId(choice.optionid);
            const nextChoice = allComboChoices[index + 1];
            const lastSelectedItem = this.state.currentSelectedItems[this.state.currentSelectedItems.length - 1];
            this.choiceIdOnEdit.push(choice.optionid);

            if (allComboChoices.length === 1 || !nextChoice) {
                processChoice(choice, catId);
                return;
            }

            const indentPattern = `${choice.indent}${nextChoice.indent}`;
            const combinedCost = choice.cost + nextChoice.cost;

            switch (indentPattern) {
                case "00":
                    processChoice(choice, catId);
                    break;
                case "01":
                    if (lastSelectedItem?.tiTle === choice.name) {
                        lastSelectedItem.subTitle = lastSelectedItem.subTitle
                            ? `${lastSelectedItem.subTitle}, ${nextChoice.name}`
                            : nextChoice.name;
                        lastSelectedItem.price = combinedCost;
                        lastSelectedItem.subtitleId.push(nextChoice.optionid);
                    } else {
                        processChoice(choice, catId, nextChoice.name, combinedCost, [nextChoice.optionid]);
                    }
                    this.checkAllSelectedElements(choice.name, nextChoice.name, 500);
                    break;
                case "10":
                    processChoice(nextChoice, catId);
                    break;
                case "11":
                case "21":
                    lastSelectedItem.subTitle += `, ${nextChoice.name}`;
                    lastSelectedItem.subtitleId.push(nextChoice.optionid);
                    this.checkAllSelectedElements(lastSelectedItem.tiTle, nextChoice.name, 500);
                    break;
                case "12":
                    lastSelectedItem.subTitle += `, ${nextChoice.name}`;
                    lastSelectedItem.subtitleId.push(choice.optionid, nextChoice.optionid);
                    this.checkAllDropdownElements(choice.optionid, nextChoice.optionid, choice.name, nextChoice.name, 1000, 2000);
                    break;
                case "20":
                    console.log("Indent pattern 20, processing next choice:", nextChoice.name); 
                    processChoice(choice, catId);
                    break;
            }
        });
        //console.log("currentSelectedItems after buildSelectedOrders", this.state.currentSelectedItems); 
        $(".js-pdp-add-to-bag").attr("data-choiceids", this.choiceIdOnEdit);
        this.checkButtonStatusOnCardClick();
        this.setState({ editPage: true });
    }

    */

    buildSelectedOrders() {
        var allComboChoices = this.pdpOrdersDataForEdit.choices
        allComboChoices.map((orderChoice, index) => {
            const catId = this.getModifierGroupIdByMenuDetailId(orderChoice.optionid);

            var modifierIds = [];
            this.choiceIdOnEdit.push(orderChoice.optionid)
            var current = index;
            var next = index + 1;
            var lastSelectedItemInOrderBagIndex = this.state.currentSelectedItems.length - 1
            var lastObjectInCurrentSelectedItems = this.state.currentSelectedItems[lastSelectedItemInOrderBagIndex]

            if (allComboChoices.length == 1) {
                this.state.currentSelectedItems.push(this.returnCartItemObject(
                    catId,
                    allComboChoices[current].name,
                    allComboChoices[current].optionid,
                    allComboChoices[current].calories,
                    null,
                    allComboChoices[current].cost,
                    allComboChoices[current].image,
                    null,
                    allComboChoices[current].calorieSeparator,
                    allComboChoices[current].maxcalories
                ));
            }
            else if (next < allComboChoices.length) {
                var currentOrderIndent = (allComboChoices[current].indent).toString();
                var nextOrderIndent = (allComboChoices[next].indent).toString();
                var allCost = allComboChoices[next].cost + allComboChoices[current].cost
                var indentCodepattern = currentOrderIndent + nextOrderIndent

                switch (indentCodepattern) {
                    case "00":
                        if (current == 0) {
                            this.state.currentSelectedItems.push(this.returnCartItemObject(
                                catId,
                                allComboChoices[current].name,
                                allComboChoices[current].optionid,
                                allComboChoices[current].calories,
                                null,
                                allComboChoices[current].cost,
                                allComboChoices[current].image,
                                null,
                                allComboChoices[current].calorieSeparator,
                                allComboChoices[current].maxcalories
                            ));

                            this.state.currentSelectedItems.push(this.returnCartItemObject(
                                catId,
                                allComboChoices[next].name,
                                allComboChoices[next].optionid,
                                allComboChoices[next].calories,
                                null,
                                allComboChoices[next].cost,
                                allComboChoices[next].image,
                                null,
                                allComboChoices[current].calorieSeparator,
                                allComboChoices[current].maxcalories
                            ));

                        } else {
                            //if current is present, only push next
                            var isFound = this.state.currentSelectedItems.filter((orderItemObj) => {
                                return (orderItemObj.tiTle == allComboChoices[current].name);
                            })

                            if (isFound.length > 0) {
                                this.state.currentSelectedItems.push(this.returnCartItemObject(
                                    catId,
                                    allComboChoices[next].name,
                                    allComboChoices[next].optionid,
                                    allComboChoices[next].calories,
                                    null,
                                    allComboChoices[next].cost,
                                    allComboChoices[next].image,
                                    null,
                                    allComboChoices[current].calorieSeparator,
                                    allComboChoices[current].maxcalories
                                ));
                            } else if (isFound.length == 0) {
                                this.state.currentSelectedItems.push(this.returnCartItemObject(
                                    catId,
                                    allComboChoices[current].name,
                                    allComboChoices[current].optionid,
                                    allComboChoices[current].calories,
                                    null,
                                    allComboChoices[current].cost,
                                    allComboChoices[current].image,
                                    null,
                                    allComboChoices[current].calorieSeparator,
                                    allComboChoices[current].maxcalories
                                ));
                                //Commenting this out because it seems redundant to push the next item again if it's already being pushed above.
                                //Uncomment if needed.
                                //Fix for:  category ID issue, required status issue in edit flow
                               /* this.state.currentSelectedItems.push(this.returnCartItemObject(
                                    catId,
                                    allComboChoices[next].name,
                                    allComboChoices[next].optionid,
                                    allComboChoices[next].calories,
                                    null,
                                    allComboChoices[next].cost,
                                    allComboChoices[next].image,
                                    null,
                                    allComboChoices[current].calorieSeparator,
                                    allComboChoices[current].maxcalories
                                ));*/
                            }
                        }
                        break;
                    case "01":
                        if (current == 0) {
                            modifierIds.push(allComboChoices[next].optionid)
                            this.state.currentSelectedItems.push(this.returnCartItemObject(
                                catId,
                                allComboChoices[current].name,
                                allComboChoices[current].optionid,
                                allComboChoices[current].calories,
                                allComboChoices[next].name,
                                allCost,
                                allComboChoices[current].image,
                                modifierIds,
                                allComboChoices[current].calorieSeparator,
                                allComboChoices[current].maxcalories
                            ));
                        }
                        else {
                            var isFound = this.state.currentSelectedItems.filter((orderItemObj) => {
                                return (orderItemObj.tiTle == allComboChoices[current].name);
                            })
                            if (isFound.length > 0) {
                                // modifierIds.push(allComboChoices[next].optionid)
                                if (lastObjectInCurrentSelectedItems.subTitle === null) {
                                    lastObjectInCurrentSelectedItems.subTitle = allComboChoices[next].name;
                                } else {
                                    lastObjectInCurrentSelectedItems.subTitle += ", " + allComboChoices[next].name;
                                }
                                lastObjectInCurrentSelectedItems.price = allCost
                                modifierIds.push(allComboChoices[next].optionid)
                                lastObjectInCurrentSelectedItems.subtitleId = modifierIds
                            } else if (isFound.length == 0) {
                                modifierIds.push(allComboChoices[next].optionid)
                                this.state.currentSelectedItems.push(this.returnCartItemObject(
                                    catId,
                                    allComboChoices[current].name,
                                    allComboChoices[current].optionid,
                                    allComboChoices[current].calories,
                                    allComboChoices[next].name,
                                    allCost,
                                    allComboChoices[current].image,
                                    modifierIds,
                                    allComboChoices[current].calorieSeparator,
                                    allComboChoices[current].maxcalories
                                ));
                            }
                        }
                        this.checkAllSelectedElements(allComboChoices[current].name, allComboChoices[next].name, 500);
                        break;
                    case "10":
                        if (next == (allComboChoices.length - 1)) {
                            this.state.currentSelectedItems.push(this.returnCartItemObject(
                                catId,
                                allComboChoices[next].name,
                                allComboChoices[next].optionid,
                                allComboChoices[next].calories,
                                null,
                                allComboChoices[next].cost,
                                allComboChoices[next].image,
                                null,
                                allComboChoices[next].calorieSeparator,
                                allComboChoices[next].maxcalories,
                            ));
                        }
                        break;
                    case "11":
                        lastObjectInCurrentSelectedItems.subTitle += ", " + allComboChoices[next].name
                        modifierIds.push(allComboChoices[next].optionid)
                        lastObjectInCurrentSelectedItems.subtitleId = modifierIds
                        this.checkAllSelectedElements(lastObjectInCurrentSelectedItems.tiTle, allComboChoices[next].name, 500);
                        break;
                    case "12":
                        lastObjectInCurrentSelectedItems.subTitle += ", " + allComboChoices[next].name
                        modifierIds.push(allComboChoices[current].optionid)
                        modifierIds.push(allComboChoices[next].optionid)
                        lastObjectInCurrentSelectedItems.subtitleId = modifierIds
                        this.checkAllDropdownElements(allComboChoices[current].optionid, allComboChoices[next].optionid, allComboChoices[current].name, allComboChoices[next].name, 1000, 2000);
                        break;
                    case "21":
                        lastObjectInCurrentSelectedItems.subTitle += ", " + allComboChoices[next].name
                        modifierIds.push(allComboChoices[next].optionid)
                        lastObjectInCurrentSelectedItems.subtitleId = modifierIds
                        this.checkAllSelectedElements(lastObjectInCurrentSelectedItems.tiTle, allComboChoices[next].name, 500);
                        break;
                    case "20":
                        if (current == (allComboChoices.length - 1)) {
                            this.state.currentSelectedItems.push(this.returnCartItemObject(
                                catId,
                                allComboChoices[current].name,
                                allComboChoices[current].optionid,
                                allComboChoices[current].calories,
                                null,
                                allComboChoices[current].cost,
                                allComboChoices[current].image,
                                allComboChoices[current].calorieSeparator,
                                allComboChoices[current].maxcalories,
                                modifierIds
                            ));
                        }
                        break;
                }
            }
            //redistribute the ids
        })


        //add orderids to the order button
        $(".js-pdp-add-to-bag").attr("data-choiceids", this.choiceIdOnEdit);
        //enable the orderButton
        $(".add-to-bag-button  button").attr('disabled', false).attr('tabindex', '0')
        $(".add-to-bag-button  button").focus()
        this.setState({ editPage: true });
    }



    checkAllDropdownElements(selectedItemId, selectedSubCheckboxId, selectedDropdownTitle, subCheckbox, delayExecution, delayExecutionForSub) {
        $('#comboSaveButton').prop('disabled', false)
        $(document).ready(function (e) {
            ////console.log(selectedItemId, selectedSubCheckboxId, selectedDropdownTitle, subCheckbox, delayExecution, delayExecutionForSub)
            var autoCheckSelectedCheveron = () => {
                var SelectedChevron = $('i[data-toppingid="' + selectedItemId + '"]')
                SelectedChevron.attr("data-selected", "selected")
                SelectedChevron.closest(".cart-items").addClass("selected");
                SelectedChevron.parent('div#moreOptions').parent('div.col-2').siblings('.js-cart-item-product-img').find('i.selected-combo').removeClass('d-none');
            }
            setTimeout(autoCheckSelectedCheveron, delayExecution);
        })
    }

    checkAllSelectedElements(selectedItemTitle, subTitleContent, delayExecution) {
        $(document).ready(function (e) {
            $('#comboSaveButton').prop('disabled', false);
            var getSelecteModItem = $('button[data-selectedtitle="' + selectedItemTitle + '"]').parent().closest('.cart-items').find('.item-description').text();
           // //console.log("getSelecteModItem ** ", getSelecteModItem);
          //  //console.log("subTitleContent ** ", subTitleContent);
            if (subTitleContent == getSelecteModItem) {
              //  //console.log("getSelecteModItem and subTitleContent match ** ");
                $('button[data-selectedtitle="' + selectedItemTitle + '"]').click(function (e) {
                    var checkSelectedCheckBoxes = () => { $('div[data-name="' + selectedItemTitle + '"] input[value="' + subTitleContent + '"]').attr('checked', true) }
                    setTimeout(checkSelectedCheckBoxes, delayExecution)
                })
            }
        });
    }

    returnCartItemObject(categoryId, cartItemTitle, cartItemId, cartItemCalories,
        cartItemSubtitle, cartItemPrice, cartItemImage, cartItemSubtitleId, cartItemCalSeparator, cartItemMaxCal) {
        this.pdpOrdersDataForEdit.basecost == null ? 0 : this.pdpOrdersDataForEdit.basecost
        //all modal triggered by cards must have the same id as the cards
        this.state.modalId = cartItemId
        this.state.selectedCardId = cartItemId
        return (
            {
                tiTle: cartItemTitle,
                id: cartItemId,
                subtitleId: cartItemSubtitleId,
                calories: cartItemCalories,
                categoryId: categoryId,
                subTitle: cartItemSubtitle, // create a method to return subtitles
                price: cartItemPrice,
                priceOnCoverstionToEditMode: this.pdpOrdersDataForEdit.totalcost,
                basePrice: this.pdpOrdersDataForEdit.basecost,
                image: cartItemImage,
                isEditMode: true,
                quantity: this.pdpOrdersDataForEdit.quantity,
                // this.pdpOrdersDataForEdit.image-the real image source ref - add later TODO,
                hideShowSelectedItemOnClose: [false],
                updatedId: [],
                moreOptionsAvailable: this.getOptionGroupDataForEdit(cartItemTitle, cartItemId),
                disableModalOnLoad: true,
                // this generates the custimize buttton
                sendId: this.getIdForCloseButton,
                sendIdData: this.getIdDataForCardRemoval,
                passExtraToppingssDataForComboToppingsComp: this.receiveToppingsDataForToppingComp,
                passModalHeaderTextForComboToppingsComp: this.receiveModalHeaderTextForComboToppingsComp,
                passModalHeaderIdForComboToppingsComp: this.receiveModalHeaderIdForComboToppingsComp,
                sendModalImage: this.receiveModalImage,
                sendIdDataToResetAllModalControls: this.getIdDataToResetAllModalControls,
                sendTitleDataToShowMenuOrderPanel: this.getSelecetedItemTitleToShowMenuOrderPanel,
                sendRightModalHeadingData: this.getRightModalHeadingData,
                sendExtrasPrice: this.getExtrasPrice,
                resetCardOpensModalStatus: this.resetCardOpensModalStatus,
                sendCardOpensModalState: this.getCardOpensModalState,
                sendNotificationToResetCheckboxes: this.getNotificationToResetCheckboxes,
                sendModalContentResetStatus: this.getModalResetState,
                sendCustomizedButtonClickedStatus: this.getCustomizedButtonClickedStatus,
                removeButtonText: this.props.data.RemoveButtonText,
                calorieAbbr: this.props.data.CalorieAbbr,
                caloriesText: this.props.data.CaloriesText,
                calorieAdds: this.props.data.CalorieAdds,
                calorieSubtracts: this.props.data.CalorieSubtracts,
                customizeButtonText: this.props.data.CustomizeButtonText,
                calorieSeparator: cartItemCalSeparator,
                maxCalories: cartItemMaxCal
            }
        )
    }

    getOptionGroupDataForEdit(selectedItemTitle, selectedTitleId) {
        var optionGroups = [];
        this.allComboData.ModifierGroups.map((ModifierGroup) => {
            ModifierGroup.Modifiers.map((modifier) => {
                if (selectedTitleId == modifier.MenuItemDetail.Id
                ) {
                    optionGroups = modifier.optionGroups
                }
            })
        });
        return optionGroups
    }


    getSelectedMenuCardData(cardData, catId, updateExtraPrice) {
       // //console.log("getSelectedMenuCardData called with cardData:", cardData, "and catId:", catId);
        var selectedItem = {}
        

       // //console.log("allCardIdData", this.state.allCardIdData);
        var selectedCardData = this.state.allCardIdData.filter((aCardData) => {
            return (cardData == aCardData.MenuItemDetail.Id);
        });

       // //console.log("selectedCardData", selectedCardData)
        if (selectedCardData.length > 0) {
            this.state.modalId = selectedCardData[0].MenuItemDetail.Id

            //Dynamically loads users selection on the customized panel
            selectedItem = {
                tiTle: selectedCardData[0].MenuItemDetail.Name,
                id: selectedCardData[0].MenuItemDetail.Id,
                subtitleId: "",
                categoryId: catId,
                calories: selectedCardData[0].MenuItemDetail.BaseCalories,
                calorieSeparator: selectedCardData[0].MenuItemDetail.CalorieSeparator,
                maxCalories: selectedCardData[0].MenuItemDetail.MaxCalories,
                subTitle: selectedCardData[0].MenuItemDetail.Description,
                price: selectedCardData[0].MenuItemDetail.CalcPrice,
                image: selectedCardData[0].MenuItemDetail.ImagePath,
                hideShowSelectedItemOnClose: this.state.removeOrPersistSelectedItem,

                moreOptionsAvailable: selectedCardData[0].optionGroups,

                sendPreselected: this.getNameListForModalMultiples,
                disableModalOnLoad: false,
                isEditMode: false,
                quantity: this.pdpOrdersDataForEdit.quantity,
                sendIdDataToResetAllModalControls: this.getIdDataToResetAllModalControls,
                sendId: this.getIdForCloseButton,
                sendIdData: this.getIdDataForCardRemoval,
                passExtraToppingssDataForComboToppingsComp: this.receiveToppingsDataForToppingComp,
                passModalHeaderTextForComboToppingsComp: this.receiveModalHeaderTextForComboToppingsComp,
                passModalHeaderIdForComboToppingsComp: this.receiveModalHeaderIdForComboToppingsComp,
                sendModalImage: this.receiveModalImage,
                sendTitleDataToShowMenuOrderPanel: this.getSelecetedItemTitleToShowMenuOrderPanel,
                sendRightModalHeadingData: this.getRightModalHeadingData,
                sendExtrasPrice: this.getExtrasPrice,
                resetCardOpensModalStatus: this.resetCardOpensModalStatus,
                sendCardOpensModalState: this.getCardOpensModalState,
                sendNotificationToResetCheckboxes: this.getNotificationToResetCheckboxes,
                updatedId: this.state.updatedId,
                sendModalContentResetStatus: this.getModalResetState,
                sendCustomizedButtonClickedStatus: this.getCustomizedButtonClickedStatus,
                removeButtonText: this.props.data.RemoveButtonText,
                calorieAbbr: this.props.data.CalorieAbbr,
                caloriesText: this.props.data.CaloriesText,
                calorieAdds: this.props.data.CalorieAdds,
                calorieSubtracts: this.props.data.CalorieSubtracts,
                customizeButtonText: this.props.data.CustomizeButtonText
            }

            this.state.cardNameClicked = selectedItem.tiTle;
            //Accumulator
            this.state.currentSelectedItems.push(selectedItem);
        }

        this.setState({
            currentSelectedItems: this.state.currentSelectedItems
        })
        if (updateExtraPrice) {
            this.getExtrasPrice(updateExtraPrice,"add");
        }

        this.renderChoiceIds(this.listOfChoiceIds);

/*        setTimeout(
            () => {
                $('html, body').animate({
                    scrollTop: ($("#selectAnchor").position()) ? ($(window).width() <= '575') ? $("#selectAnchor").position().top + $(".combo-body").height() + 45 : $("#selectAnchor").position().top - 46 : null
                }, 500);
            }, 0)*/

    }

    renderChoiceIds(listOfChoiceIds) {

        //console.log("renderChoiceIds called with listOfChoiceIds:", listOfChoiceIds);   
        var choiceIds = []
        var currentParentId = "";
        var currentChildId = ""
            /*$("#selectedList h5").each(function (index) {
                currentParentId = $(this)[0].id
                if (currentParentId != "") {
                    choiceIds.push(currentParentId);
                    //push the child ids if any
                    $("#" + currentParentId).siblings("p.item-description").each(function (index) {
                        currentChildId = $(this)[0].id
                        if (currentChildId != "") {
                            choiceIds.push(currentChildId);
                        }
                    });
                }
                       
            });*/
            
        //console.log("this.state.currentSelectedItems", this.state.currentSelectedItems);

            this.state.currentSelectedItems.forEach((selectedItem) => {
                if (selectedItem.id) {
                    choiceIds.push(selectedItem.id);
                    //console.log("selectedItem.id", selectedItem.id);
                    //console.log("selectedItem.subtitleId", selectedItem.subtitleId);
                    if (selectedItem.subtitleId) {  
                       if (Array.isArray(selectedItem.subtitleId)) {  
                           selectedItem.subtitleId.forEach((subId) => {  
                               if (subId) {  
                                   choiceIds.push(subId);  
                               }  
                           });  
                       } else {  
                           choiceIds.push(selectedItem.subtitleId);  
                       }  
                    }
                }
            });


            var allChoiceIds = [...listOfChoiceIds, ...choiceIds]
            //console.log("allChoiceIds", allChoiceIds);
            $(".js-pdp-add-to-bag").attr("data-choiceids", allChoiceIds)
        this.checkButtonStatusOnCardClick();

    }

    renderChoiceIdsOnSave() {
        this.renderChoiceIds(this.listOfChoiceIds)
    }

    getNotificationToResetCheckboxes(parentToppingTitle) {
        this.state.checkboxInfo.pop(); // drain the state variable
        this.state.checkboxInfo.push(parentToppingTitle) // receives the latest status
        this.setState({ checkboxInfo: this.state.checkboxInfo })
    }

    getCardOpensModalState(cardOpensModal) {
        //console.log("getCardOpensModalState called with cardOpensModal:", cardOpensModal);
        this.setState({ cardOpensModal: cardOpensModal })
    }

    getModalResetState(modalResetState) {
        this.setState({ resetModal: modalResetState })
    }

    getIdForCloseButton(currentId) {
        this.state.updatedId.pop(); // drain the state variable
        this.state.updatedId.push(currentId) // receives the latest status

        this.setState({
            updatedId: this.state.updatedId
        })
    }

    resetCardOpensModalStatus(resetState) {
        this.state.removeOrPersistSelectedItem.pop(); // drain the state variable
        this.state.removeOrPersistSelectedItem.push(resetState) // receives the latest status

        this.setState({
            removeOrPersistSelectedItem: this.state.removeOrPersistSelectedItem
        })
    }

    //Remove Items
    getIdDataForCardRemoval(cardIdDataForRemoval) {

        this.state.idOfremovedCard = cardIdDataForRemoval;
        var cardsRemainingAfterRemoval = this.state.currentSelectedItems.filter((aCardData) => {
            return (cardIdDataForRemoval != aCardData.id);
        });

       
        this.state.currentSelectedItems = cardsRemainingAfterRemoval;
        this.setState({currentSelectedItems: this.state.currentSelectedItems })

        //order button will always be disabled when items are removed
        //$(".add-to-bag-button  button").attr('disabled', true)

        this.renderChoiceIds(this.listOfChoiceIds)
    }

    getUpdatedExtrasPrice(updateddExtras) {
        //console.log("getUpdatedExtrasPrice extrasPrice in state:", updateddExtras, this.state.extrasPrice);

        this.setState({ extrasPrice: updateddExtras })
    }

    //method triggerd by close button
    getModalInfoToRemoveSelecetedItem(didCardOpenModal) {
        //console.log("getModalInfoToRemoveSelecetedItem called with didCardOpenModal:", didCardOpenModal);   
        this.state.removeOrPersistSelectedItem.pop(); // drain the state variable
        this.state.removeOrPersistSelectedItem.push(didCardOpenModal) // receives the latest status
        //console.log("getModalInfoToRemoveSelecetedItem updated removeOrPersistSelectedItem:", this.state.removeOrPersistSelectedItem);
        this.setState({
            removeOrPersistSelectedItem: this.state.removeOrPersistSelectedItem
        })
    }

    //when cards are removed
    getSelecetedItemTitleToShowMenuOrderPanel(selectedItemTitle) {
        var MenuOrderPanelsShown = [];
        this.allComboData.ModifierGroups.map((panelObj, index) => {
            panelObj.Modifiers.map((modifier) => {

                if (this.state.idOfremovedCard == modifier.MenuItemDetail.Id) {
                    
                    this.state.allOrderPanels[index] = panelObj

                    if (!panelObj.IsRequired) {
                        this.state.filteredOptionalCards[index].push(modifier);
                    }

                    MenuOrderPanelsShown = this.state.allOrderPanels
                    this.setState({ allOrderPanels: MenuOrderPanelsShown })

                    this.allRequiredChoices = this.allRequiredChoices.filter((unHiddenTitle) => {
                        return (panelObj.Name != unHiddenTitle.Name);
                    });
                }
            })
        });
       
        
        //Activate the Orderbag button once all the required items are selected
        /*if (this.allRequiredChoices.length == this.noOfRequiredTitles) {
            $(".add-to-bag-button  button").attr('disabled', false).attr('tabindex', '0')
            $(".add-to-bag-button  button").focus()

        }*/

    }
   /* checkAllRequiredCompleted() {


    }*/
    receiveModalImage(modalImage) {
        if (modalImage) {
            this.setState({ ModalImage: modalImage })
        }
    }

    getUpdatedToppingData(updatedToppingData) {
    }

    getToppingHeaderTitleWithSub(selectionHeaderObj) {
    }

    getCustomizedButtonClickedStatus(CustomizedButtonClickedStatus) {
        this.setState({ isCustomizedButtonClicked: CustomizedButtonClickedStatus })

    }

    getNameListForModalMultiples(selectionsData) {
        //console.log("getNameListForModalMultiples called with selectionsData:", selectionsData);
        // console.log("currentSelectedItems before update:", this.state.currentSelectedItems);    

        var selectionsObj = this.state.currentSelectedItems.filter((selectedItemToBeModified) => {
            return (selectedItemToBeModified.tiTle == selectionsData.parentTitle);
        });


        selectionsObj[0].subTitle = selectionsData.newValue
        selectionsObj[0].subtitleId = selectionsData.listOfIds

        // console.log("selectionsObj[0].subTitle", selectionsObj[0].subTitle, "selectionsObj[0].subtitleId", selectionsObj[0].subtitleId);    

        if (this.state.isCustomizedButtonClicked) {
            //Update price
            //console.log("selectionsData.totalPrice", selectionsData.totalPrice, "selectionsObj[0].price", selectionsObj[0].price);


            this.state.extrasPrice = parseFloat(selectionsData.totalPrice) - parseFloat(selectionsObj[0].price)
        } else {
            //add price
            //console.log("selectionsData.totalPrice ---", selectionsData.totalPrice, "selectionsObj[0].price", selectionsObj[0].price);  
            this.state.extrasPrice = parseFloat(selectionsData.totalPrice)
        }

        var subTitleSelector = selectionsData.newValue
        selectionsObj[0].price = selectionsData.totalPrice

        //console.log("selectionsObj", selectionsObj)
        const itemsToAdd = Array.isArray(selectionsObj[0]) ? selectionsObj[0] : [];
        //console.log("itemsToAdd", itemsToAdd);  
        //console.log("extrasPrice in state before update:", this.state.extrasPrice); 
        this.setState({
            currentSelectedItems: [...this.state.currentSelectedItems, ...itemsToAdd]
        });
        //console.log("Updated currentSelectedItems in state:", this.state.currentSelectedItems); 
        /* this.state.currentSelectedItems = [...this.state.currentSelectedItems, ...selectionsObj[0]]
        this.setState({
            currentSelectedItems: this.state.currentSelectedItems,
        })*/

    }

    getIdForSubs(IdForSub) {
        this.getSubsLabelId = IdForSub;
    }

    getAppendedData(appendedData) {
        this.getAppendedDataObj = appendedData
    }
    getCommaJoiningDataFormenuSub(commaSeparatedData) {
    }

    //triggered by selectedComboItems to deliver the extras price
    getExtrasPrice(extrasPrice, type) {
        ////console.log("getExtrasPrice called with extrasPrice:", this.state.extrasPrice, extrasPrice, type);

        let updatePrice = this.state.extrasPrice;
        if (type === "add") {
            updatePrice = this.state.extrasPrice + parseFloat(extrasPrice);
        }
        else if (type === "remove") {
            updatePrice = this.state.extrasPrice - parseFloat(extrasPrice);
        }

        this.setState({
            extrasPrice: updatePrice
        });
        this.state.extrasPrice = updatePrice; // Update the state variable directly
       //console.log("Updated extrasPrice in state 776:", updatePrice, this.state.extrasPrice);
    }

    //invoked by the check box
    getCommaSeparatedDataForParent(menuSubSubTitle) {
    }

    receiveToppingsDataForToppingComp(toppingData) {
        if (toppingData) {
            this.ModalMainToppingsHeader = toppingData[0].Name;
            this.setState({ AllToppingsData: toppingData });
        }
    }

    receiveModalHeaderTextForComboToppingsComp(modalHeaderTitle) {
        if (modalHeaderTitle) {
            this.setState({ AllToppingsHeaderTitle: modalHeaderTitle })
        }
    }
    receiveModalHeaderIdForComboToppingsComp(modalHeaderId) {
        if (modalHeaderId) {
            this.setState({ AllToppingsHeaderId: modalHeaderId })
        }
    }

    checkButtonStatusOnCardClick() {

           const requiredCategories = this.allComboData.ModifierGroups.filter(panel => panel.IsRequired);  
           const completedCategories = requiredCategories.filter(panel => {  
               return this.state.currentSelectedItems.some(item =>  
                   panel.Modifiers.some(modifier => modifier.MenuItemDetail.Id == item.id)  
               );  
           });

        //console.log("requiredCategories", requiredCategories);  
        //console.log("completedCategories", completedCategories);    
           if (requiredCategories.length === completedCategories.length) {  
               $(".add-to-bag-button button").attr("disabled", false).attr("tabindex", "0");  
               $(".add-to-bag-button button").focus();  
           } else {  
               $(".add-to-bag-button button").attr("disabled", true);  
           }  
       
    }

    getUpdatedEditModeFromHome(editpageStatus) {
        this.setState({ editPage: editpageStatus });
    }

    getUpdatedComboPrice(updatedComboPrice) {
        var truncatedComboPrice = parseFloat(updatedComboPrice.toFixed(2));
        this.setState({ initialPrice: truncatedComboPrice })
    }
    getCardNameForModalReset(cardNameForModalReset) {
        this.state.renderCardName = cardNameForModalReset
        this.setState({ renderCardName: this.state.renderCardName })
    }


    handleInputChange(e) {
        const value = e.target.value;
        const allowedPattern = /^[a-zA-Z0-9\s.,!?'\-]*$/;
        //console.log(allowedPattern);
        if (allowedPattern.test(value)) {
            this.setState({ instruction: value, error: '' });
        } else {
            this.setState({ error: 'Only letters, numbers, and - , ! . ? \' are allowed.' });
        }
    };
    getMenuOrderCardData(panel, index) {
        if (panel.IsRequired) {
            return panel.Modifiers;
        }

        const filteredCards = this.state.filteredOptionalCards[index];
        if (filteredCards === "undefined" || filteredCards === null || typeof filteredCards === "undefined") {
            return panel.Modifiers;
        }

        if (filteredCards.length === 0) {
            if (this.state.afilterEventOccured) {
                //return this.hideRacksOnEmptyOptionData(filteredCards, panel.Name);
            }
            return panel.Modifiers;
        }

        return filteredCards;
    };
    sendDataForRemoval(id, tiTle, price) {
        ////console.log("sendDataForRemoval called with id:", id, "tiTle:", tiTle, "price:", price);
        this.getIdDataForCardRemoval(id);

        this.getIdDataToResetAllModalControls(id);

        // this.getSelecetedItemTitleToShowMenuOrderPanel(tiTle);
        //console.log("sendDataForRemoval calling getExtrasPrice with price:", Math.abs(price), "and type: remove");
        this.getExtrasPrice(Math.abs(price), "remove");
        //this.props.sendExtrasPrice(-Math.abs(0));
       // this.getNotificationToResetCheckboxes(tiTle)
        //this.checkButtonStatusOnCardClick();
        $("#information_modal").attr("id", "noModal");
    }

    render() {
        const { instruction, error } = this.state;
        return (
            <div>
                {/*<!-- ==== COMBO DEFAULT ZONE ==== -->*/}
                <section className="combo-default">
                    <div className="container-fluid">
                        <div className="row">
                            {/*<!-- ==== </ right column  ==== -->*/}
                            <div className={(this.allComboData.ModifierGroups != null && this.allComboData.ModifierGroups.length > 0) || (this.props.data.DisplayAllergyInstruction == true) ? "col-sm-6 col-md-7 col-xl-8 xs-nogutters" : "col-sm-6 offset-sm-2"}>
                                <MenuOrderComboPanel
                                    name={this.allComboData.MenuItem.Name}
                                    description={this.allComboData.MenuItem.Description}
                                    altImage={this.allComboData.MenuItem.ImageAlt}
                                    price={this.allComboData.MenuItem.CalcPrice}
                                    image={this.allComboData.MenuItem.ImageLarge}
                                    baseCalories={this.allComboData.MenuItem.BaseCalories}
                                    maxCalories={this.allComboData.MenuItem.MaxCalories}
                                    calSeparator={this.allComboData.MenuItem.CalorieSeparator}
                                    categoriesPageUrl={this.allComboData.MenuItem.PageUrl}
                                    dollarPrice={this.allComboData.MenuItem.Price}
                                    calcPrice={this.allComboData.MenuItem.CalcPrice}
                                    caloriesText={this.props.data.CaloriesText}
                                    comboMessage={this.props.data.ComboMessage}
                                    deliveryFeeStandard={this.props.data.DeliveryFeeStandard}
                                    menuLabels={this.allComboData.MenuItem.MenuItemLabels}
                                    category={this.allComboData.MenuItem.Category} />
                                {/*<!-- ==== </ combo section here  ==== -->*/}

                                <ComboOrderButton
                                    productId={this.allComboData.MenuItemId}
                                    basketProductId={this.allComboData.CartItem.id !== 0 ? this.allComboData.CartItem.id : 0}
                                    comboPrice={this.allComboData.CartItem.id !== 0 ? this.allComboData.CartItem.totalcost : this.state.initialPrice}
                                    extrasPrice={this.state.extrasPrice}
                                    sendUpdatedExtrasPrice={this.getUpdatedExtrasPrice}
                                    hasRequiredModifiers={this.allComboData.HasRequiredModifier}
                                    addToBagText={this.props.data.AddToBagText}
                                    menuUrl={this.allComboData.MenuUrl}
                                    quantity={this.pdpOrdersDataForEdit.quantity > 1 ? this.pdpOrdersDataForEdit.quantity : 1}

                                />
                            </div>

                            {/*<!-- ==== </ right column  ==== -->*/}

                            {/*<!-- ==== </ left column  ==== -->*/}
                            <div className="col-sm-6 col-md-5 col-xl-4 xs-pad-0">
                                <div id="selectedList">
                                    <div className="d-none">
                                        {/*<!-- category header  -->*/}
                                        {(this.state.currentSelectedItems.length > 0) &&
                                            <div className="menu-category mg-70">
                                                <div className="category-header">
                                                    <h2 id="selectAnchor" className="h1 category-title">{this.props.data.YourSelectionsText}</h2>
                                                </div>
                                            </div>}

                                        {/*<!-- category header  -->*/}

                                        {this.state.currentSelectedItems.map(selectedItemListAsProps => {
                                            return (
                                                <div>
                                                    <SelectedComboItem
                                                        {...selectedItemListAsProps}
                                                    />
                                                </div>
                                            );
                                        })
                                        }
                                    </div>
                                    {this.state.AllToppingsData.length > 0 &&
                                        //{/*<!-- ==== right modal ==== -->*/}
                                        <CustomizedMenuRightModal
                                            id={this.state.modalId}
                                            tiTle={this.state.AllToppingsHeaderTitle}
                                            mainId={this.state.AllToppingsHeaderId} 
                                            image={this.state.ModalImage}
                                            updateView={this.state.updateView}
                                            isRequired={this.state.AllToppingsData[0].IsRequired}
                                            toppingsInfo={this.state.AllToppingsData}
                                            currentSelectedItems={this.state.currentSelectedItems}
                                            mainToppingsHeader={this.ModalMainToppingsHeader}
                                            shouldSelectedItemsBeRemoved={this.state.cardOpensModal}
                                            commaSeparatedDataToParent={this.getCommaSeparatedDataForParent}
                                            sendModalTriggerInfo={this.getModalInfoToRemoveSelecetedItem}
                                            sendUpdatedToppingData={this.getUpdatedToppingData}
                                            getCheckBoxInfoForReset={this.state.checkboxInfo}
                                            sendUpdatedToppingHeaderAndPrice={this.getToppingHeaderTitleWithSub}
                                            sendCommaJoiningDataFormenuSub={this.getCommaJoiningDataFormenuSub}
                                            sendppendedData={this.getAppendedData}
                                            sendUpdatedPrice={this.getUpdatedPrice}
                                            sendUpdatedIdForSubs={this.getIdForSubs}
                                            sendNameListForModalMultiples={this.getNameListForModalMultiples}
                                            triggerModalInputControlReset={this.state.resetModal}
                                            revertModalResetSatus={this.getModalResetState}
                                            modalTitleReset={this.state.modalTitleForReset}
                                            cardNameForModalReset={this.state.renderCardName}
                                            sendChoiceId={this.renderChoiceIdsOnSave}
                                            IsCustomizedItem={this.getCustomizedButtonClickedStatus}
                                            cardOnlyPrice={this.state.cardOnlyPrice}
                                            saveButtonText={this.props.data.SaveButtonText}
                                            defaultModifierImage={this.props.data.DefaultModifierImage}
                                            requiredText={this.props.data.RequiredText}
                                            caloriesText={this.props.data.CaloriesText}
                                            calorieAbbr={this.props.data.CalorieAbbr}
                                            calorieAdds={this.props.data.CalorieAdds}
                                            calorieSubtracts={this.props.data.CalorieSubtracts}
                                            sendPreselectedForSubs={this.getNameListForModalMultiples}
                                            isEditMode={this.state.editPage}
                                            sendUpdatedEditMode={this.getUpdatedEditModeFromHome}
                                        />
                                        //{/*<!-- ==== right modal ==== -->*/}
                                    }

                                    {this.state.allOrderPanels.map((panel, index) => {
                                        return (
                                            <MenuOrderStepsPanel
                                                id={panel.Id}
                                                tiTle={panel.Name}
                                                maxChoices={panel.MaxChoices}
                                                maxselects={panel.maxselects}
                                                minselects={panel.minselects}
                                                description={panel.description}
                                                customizeButtonText={this.props.data.CustomizeButtonText}
                                                updateModalData={this.receiveToppingsDataForToppingComp}
                                                updateModalHeader={this.receiveModalHeaderTextForComboToppingsComp}
                                                updateModalId={this.receiveModalHeaderIdForComboToppingsComp}
                                                updateModalImage={this.receiveModalImage}
                                                sendCardOpensModalState={this.getCardOpensModalState}
                                                sendModalContentResetStatus={this.getModalResetState}
                                                sendCustomizedBtnStatus= { this.getCustomizedButtonClickedStatus }
                                                updateRenderModalState={this.updateRenderModalState }
                                                menuOrderCardData={this.getMenuOrderCardData(panel, index)}
                                                sendIdDataToParent={this.getSelectedMenuCardData}
                                                isRequired={panel.IsRequired}
                                                currentSelectedItems={this.state.currentSelectedItems}
                                                checkButtonStatusOnCardClick={this.checkButtonStatusOnCardClick}
                                                // sendPanelTitleForHideAndShow={this.getTitleDataToHideAndShow}
                                                sendCardOpensModalState={this.getCardOpensModalState}
                                                shouldModalContentBeCleared={this.getModalResetState}
                                                sendCardNameForModalReset={this.getCardNameForModalReset}
                                                sendDataForRemoval={this.sendDataForRemoval}
                                                sendCardOnlyPrice={this.getCardOnlyPrice}
                                                defaultModifierImage={this.props.data.DefaultModifierImage}
                                                requiredText={this.props.data.RequiredText}
                                                caloriesText={this.props.data.CaloriesText}
                                                calorieAbbr={this.props.data.CalorieAbbr}
                                                calorieAdds={this.props.data.CalorieAdds}
                                                calorieSubtracts={this.props.data.CalorieSubtracts}
                                            />);

                                    })

                                    }
                                    {(this.props.data.DisplayAllergyInstruction == true) && <div className="menu-category mg-70">
                                        <div className="category-header">
                                            <h2 className="category-title h1">{this.props.data.AllergyHeading}</h2>
                                        </div>
                                        <div className="category-body position-relative">
                                            <div className="row">
                                                <div className="col-sm-4 col-6 d-flex align-self-stretch pad-righ-0 ihopCustomize allergyInstructioncontainer">
                                                    <textarea id="allergyInstruction"
                                                        name="allergyInstruction"
                                                        aria-labelledby="allergyInstructionLabel"
                                                        placeholder={this.props.data.AllergyPlaceholderText}
                                                        maxLength={this.props.data.AllergyInstructionMaxLength}
                                                        data-allergyTextPrefix={this.props.data.AllergyTextPrefix}
                                                        onChange={this.handleInputChange}
                                                        value={instruction}>
                                                        {this.allComboData.CartItem.specialinstructions}
                                                    </textarea>
                                                    <p className="allergyDisclaimer">{this.props.data.AllergyDisclaimerText}</p>
                                                </div>
                                                {error && <div className="allergyError col-sm-12 col-12">{error}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>

                                {/*<!-- NUTRITIONAL MENU GOES HERE ==== -->*/}

                                {/* <AllegensAndNutritionPanel /> */}
                            </div>
                            {/*<!-- ==== </left column  ==== -->*/}

                        </div>
                        {/*<!--  /.row ==== -->*/}
                    </div>
                    {/*<!-- /.container==== -->*/}

                </section>
                {/*<!-- ==== COMBO DEFAULT ZONE ====-->*/}

            </div>

        );

    }
}